<template>
  <div class="layout-content xhm-layout">
    <!-- 广告位 -->
    <el-row
      :gutter="10"
      class="communal-0"
      style="margin-left: 0px; margin-right: 0px"
    >
      <!-- <img class="t-img" src="@/assets/banner.png" alt="" /> -->
    </el-row>
    <!-- @click="$router.push('/order/upload')" -->
    <!-- 改版首页 -->

    <!-- 查询区域 -->
    <!-- 改版首页 -->
    <h4 style="color: #bbb; font-size: 12px; font-weight: 400">
      首页最后更新时间为：{{ statistics.lastUpdateTime }}
    </h4>

    <div
      v-if="
        userInfo.role_flag == 3 ||
        userInfo.role_flag == 4 ||
        userInfo.role_flag == 5
      "
    >
      <h4 style="color: red; font-size: 20px; font-weight: 400">Tips:<br /></h4>
      <h4 style="color: #000; font-size: 20px; font-weight: 400">
        如果是免登陆进去系统的，账户登录名是:{{ userInfo.login_name }}&nbsp;
        初始密码是：123456 <br />
      </h4>
      <h4 style="color: #000; font-size: 20px; font-weight: 400">
        如需修改，请点击右上角用户名称：{{ userInfo.user_name }}。
      </h4>
    </div>
    <!-- 改版首页结束 -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import { format } from "@/utils/comm";
export default {
  data() {
    return {
      form: { timeArr: [], type: 1 },

      dayTime: "",
      tableData: [],
      statistics: "",
      statisticsForm: {
        type: 1,
        dshop_id: "",
      },
      loading: false,
      orderForm: {
        tabType: 1,
      },
      orderData: {},

      lastUpdateTime: "",

      tabType: 1,
      shop_num: 9,
    };
  },
  computed: {
    ...mapState({
      navTree: (state) => state.menu.navTree,
      userInfo: (state) => state.app.userInfo,
    }),
  },
  created: function () {
    let { user_name } = this.userInfo;
    if (!user_name) {
      this.getUserInfoFn();
    }
    let sParams = {
      days: this.statisticsForm.type,
      dshop_id: this.statisticsForm.dshop_id,
    };
  },
  mounted() {},
  filters: {
    numPartition(num) {
      if (!num) {
        return 0;
      }
      let numBefore = num.toString().split(".")[0];
      let numQueen = num.toString().split(".")[1];
      let decimals = parseInt(numQueen) > 0 ? true : false;
      return (
        (numBefore || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,") +
        (decimals ? "." + numQueen : "")
      );
    },
  },
  methods: {
    //获取用户信息
    async getUserInfoFn() {
      if (this.loading) return;
      this.loading = true;
      const { status, data, message } = await this.$api.comApi.getUserInfo();
      status === "0"
        ? this.$store.commit("handleUserInfo", data || {})
        : this.$message({ showClose: true, message, type: "error" });
      this.loading = false;
    },
    // 下拉框变化事件
    selectChange(value) {
      this.shop_num = value;
      // this.getRate();
    },
    tab(type) {
      this.tabType = type;
      if (this.tabType == 1) {
        this.tableData = this.weekSaleCount.slice(
          parseInt(this.page - 1) * this.size,
          parseInt(this.page * this.size)
        );
        this.total = this.weekSaleCount.length;
      } else {
        this.tableData = this.monthSaleData.slice(
          parseInt(this.page - 1) * this.size,
          parseInt(this.page * this.size)
        );
        this.total = this.monthSaleData.length;
      }
    },
    statisticsTab(type) {
      this.statisticsForm.type = type;
      let sParams = { days: type, dshop_id: this.statisticsForm.dshop_id };
    },

    //查询
    async querySearchAsync() {
      let sParams = {
        days: this.statisticsForm.type,
        dshop_id: this.statisticsForm.dshop_id,
      };
    },
  },
};
</script>

<style lang="scss">
.show {
  opacity: 0;
}
.isActive {
  background: #ecf5ff !important;
  border-color: #2187e7 !important;
  color: #2187e7 !important;
  margin-right: 0 !important;
  border-radius: 0px;
  border-right: 1px solid #2187e7 !important;
}
.btn {
  // border-color: #2187e7 !important;
  color: #000;
  border-radius: 0px;
  border-right: 0px;
}
.layout-content {
  width: 100%;
  box-sizing: border-box;
  .t-img {
    display: block;
    width: 100%;
    height: 200px;
    // object-fit: cover;
    // object-position: center center;
  }
  .communal-0 {
    border-radius: 6px;
    margin-bottom: 16px;
    overflow: hidden;
    .box {
      width: 49%;
      height: 370px;
    }
    .ranking {
      border-bottom: 1px solid #f2f2f2;
      height: 6px;
      line-height: 6px;
      font-size: 16px;
      padding-left: 20px;
      margin-bottom: 10px;
    }
  }
  .communal-8 {
    padding: 8px;
    background: #fff;
    border-radius: 6px;
    margin-bottom: 16px;
    border: 1px solid rgb(212, 211, 211);
  }
  .communal-15 {
    padding: 22px 15px;
    background: #fff;
    border-radius: 6px;
    margin-bottom: 16px;
    border: 1px solid rgb(212, 211, 211);
  }
  .new-communal-15 {
    padding: 8px 12px;
    background: #fff;
    border-radius: 6px;
    margin-bottom: 16px;
    height: 150px;
    overflow: hidden;
    border: 1.5px solid rgb(212, 211, 211);
    .new-flex-box {
      display: flex;
      justify-content: space-between;
      color: #bbb;
      font-size: 14px;
    }
    .title {
      margin-top: 2px;
      font-size: 26px;
      margin-bottom: 10px;
    }
    .text {
      color: #bbb;
      font-size: 14px;
    }
    .tag-img {
      width: 11px;
      height: 11px;
    }
    .back-img {
      padding-top: 0px;
      width: 100%;
      height: 96px;
    }
    .down {
      transform: rotate(180deg);
    }
    .bar {
      margin-top: 25px;
      height: 15px;
      width: 100%;
      background: #f4f4f4;
      position: relative;
      .bar-child {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 60%;
        background: #1890ff;
      }
    }
    .hr {
      margin-top: 10px;
      height: 1px;
      width: 100%;
      background: #ececec;
    }
    .buttom-text {
      font-size: 14px;
      margin-top: 6px;
      color: #808080;
    }
  }
  .card-box {
    display: flex;
    font-size: 14px;
    justify-content: space-between;
    align-items: center;
  }
  .flex-box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    h4 {
      font-size: 24px;
      margin: 0;
      margin-bottom: 16px;
    }
  }
  .flex-around {
    justify-content: space-around;
  }
  .flex-content {
    justify-content: space-between;
  }
  .flex-centent {
    display: flex;
    align-items: center;
    box-sizing: border-box;
  }
  .wrap {
    display: flex;
    flex-wrap: wrap;
  }
  .direction {
    display: flex;
    flex-direction: column;
  }
  .icon-img {
    // width: 40px;
    display: block;
  }
  .active-hover {
    span {
      font-size: 12px;
      cursor: pointer;
      padding: 4px 0;
      color: #bbb;
      &:hover {
        color: #f45656;
      }
    }
  }
  .box-num {
    box-sizing: border-box;
    padding-top: 16px;
    .el-col {
      text-align: center;
      cursor: pointer;
      &:hover {
        span {
          color: #f45656;
        }
      }
      span {
        font-size: 12px;
        color: #bbb;
      }
      .num {
        margin-top: 10px;
        font-size: 20px;
        font-weight: bold;
      }
    }
  }
  .box-whilt {
    display: flex;
    .communal-15 {
      box-sizing: border-box;
      width: 100%;
    }
    .communal-8 {
      box-sizing: border-box;
      width: 100%;
    }
  }
  .box-rate {
    text-align: center;
    h3 {
      margin: 0;
      font-size: 22px;
      margin-bottom: 10px;
    }
    span {
      font-size: 14px;
      color: #bbb;
    }
  }
  .css20 {
    flex: 1;
    font-size: 12px;
    padding: 0 8px;
    box-sizing: border-box;
    h4 {
      margin: 0;
    }
    p {
      margin: 0;
    }
  }
  .css10 {
    margin-bottom: 10px;
  }
  .tabs {
    font-size: 14px;
    padding: 5px 0;
    margin: 0 10px;
    cursor: pointer;
    font-weight: bold;
    border-bottom: 3px solid transparent;
    &:hover {
      color: #eb3626;
    }
  }
  .tabs-active {
    border-color: #eb3626;
    color: #eb3626;
  }
  @media only screen and (min-width: 992px) {
    .css1 {
      .el-col-md-4 {
        width: 20%;
      }
    }
  }
  @media only screen and (max-width: 768px) {
    .css10 {
      margin-bottom: 0px;
    }
  }
  .el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
  }
  .el-table__body tr,
  .el-table__body td {
    padding: 0;
    height: 37px;
  }
  .el-table::before {
    height: 0px;
  }
  .statisticsIntro {
    position: relative;
    display: flex;
    margin: 0 0 30px;
    padding: 35px 0px 5px;
    text-align: center;
    font-family: "Hiragino Sans GB";
    justify-content: space-around;
    box-shadow: 1px 2px 10px rgba(0, 0, 0, 0.2);
  }
  .titleSub {
    position: absolute;

    top: 2px;
    left: 50%;
    transform: translateX(-50%);
    font-weight: 700;
    font-size: 16px;
    padding: 0;
  }
  .statisticsIntro > .part {
    width: 1px;
    height: 58px;
    margin: 0 8px;
    background: #ccc;
  }
  .statisticsIntro > .subfield {
    flex: 1;
  }
  .statisticsIntro > .subfield > p {
    margin: 3px 0 10px;
  }
  .statisticsIntro > .subfield > span {
    color: #a6e22e;
  }
}
</style>
